import script from "./SendRequest.vue?vue&type=script&setup=true&lang=js"
export * from "./SendRequest.vue?vue&type=script&setup=true&lang=js"

import "./SendRequest.vue?vue&type=style&index=0&id=4eeb1504&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-4eeb1504"]])

export default __exports__